module.exports = __webpack_public_path__ + "img/P5.ce01464.png";